import type { PropsWithChildren } from 'react'

import { DefaultFollowUpMessageFetchProvider } from '@/modules/creator-settings/follow-up-messages/service/follow-up-message-fetch-context'
import { MessageMediaQueryProvider } from '@/modules/message/query/message-media-query-context'
import { DefaultMessageMediaProvider } from '@/modules/message/service/message-fetch-context'

export const FollowUpMessagesModule = ({ children }: PropsWithChildren) => {
  return (
    <DefaultMessageMediaProvider>
      <MessageMediaQueryProvider>
        <DefaultFollowUpMessageFetchProvider>
          {children}
        </DefaultFollowUpMessageFetchProvider>
      </MessageMediaQueryProvider>
    </DefaultMessageMediaProvider>
  )
}
